import { FederalTaxPaymentModelDto } from '@treasury/api/bo';
import { AchTaxPayment } from './ach-tax-payment.entity';
import { defaultAchTaxPaymentModelDto } from './data/ach.data';

export class AchFederalTaxPayment extends AchTaxPayment<FederalTaxPaymentModelDto> {
    public createDefault(): this {
        return new AchFederalTaxPayment(
            defaultAchTaxPaymentModelDto as FederalTaxPaymentModelDto
        ) as this;
    }

    public get type() {
        return 'Federal';
    }
}
